
import DpitColorWithHslFeatures from './DpitColorWithHslFeatures';
import DpitColor from './DpitColor';
import DpitColorAnalyze from './DpitColorAnalyze';

export default class AdminThemeColors {
	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT AdminThemeColors');
		if (config.adminColors?.colors?.legacy?.length >= 3) {
			const legacyColors = config.adminColors.colors.legacy;
			const adminColorsObj = [];
			for (let i = 0; i < 4; i++) {
				const colorIdx = i + 1;
				if (legacyColors[i]) {
					const adminColor = new DpitColorWithHslFeatures(legacyColors[i]);
					if (adminColor) {
						adminColor.setAsCssVariable(`--dpu-color-${colorIdx}`);
						adminColorsObj.push(adminColor);
						if (colorIdx === 1) {
							const bgAccent = adminColor.setLightness(95);
							bgAccent.setAsCssVariable(`--dpu-color-${colorIdx}-light`);
						}
						const textColor = DpitColorAnalyze.getContrastColor(legacyColors[i], true);
						textColor.setAsCssVariable(`--dpu-color-${colorIdx}-text`);
					}
				}
			}
			if (config.adminColors.colors.actual) {
				Object.keys(config.adminColors.colors.actual).forEach(key => {
					const adminColor = new DpitColorWithHslFeatures(config.adminColors.colors.actual[key]);
					if (adminColor) {
						adminColorsObj.push(adminColor);
					}
				});
			}
			if (adminColorsObj && config.adminColors.addRgbVars) {
				['r', 'b', 'g'].forEach((rgbIdx) => {
					let color = DpitColorAnalyze.getMostColor(adminColorsObj, rgbIdx);
					if (config.adminColors.rgbFeatureThresh && config.adminColors.rgbDefaults && config.adminColors.rgbDefaults[rgbIdx]) {
						const feature = DpitColorAnalyze.getRgbHueFeature(rgbIdx, color);
						//console.log('Color: ', color, 'RGB:', rgbIdx, 'Feature:', feature);
						if (feature < config.adminColors.rgbFeatureThresh) {
							/*if (rgbIdx !== 'r') color = DpitColorAnalyze.getRgbHueAdjustedColor(rgbIdx, color);
								else color = Color(config.adminColors.rgbDefaults[rgbIdx]);*/
							//color = Color(config.adminColors.rgbDefaults[rgbIdx]);
							color = new DpitColor(config.adminColors.rgbDefaults[rgbIdx]);
						}
					}
					color.setAsCssVariable(`--dpu-color-${rgbIdx}`);
					const textColor = DpitColorAnalyze.getContrastColor(color);
					textColor.setAsCssVariable(`--dpu-color-${rgbIdx}-text`);
					const index = adminColorsObj.indexOf(color);
					if (index !== -1) {
						adminColorsObj.splice(index, 1);
					}
				});
			}

		}
	}
}
